import { GridColDef } from "@mui/x-data-grid";

export const employeesColumns: GridColDef[] = [
  { field: "surveyId", headerName: "Orden", width: 70, align: "center" },
  { field: "surveyStatus", headerName: "Estado encuesta", type: "string", width: 130, align: "center" },
  { field: "surveySections", headerName: "Páginas completadas", type: "string", width: 160, align: "center" },
  { field: "surveyPercentage", headerName: "Avance Encuesta (%)", type: "string", width: 150, align: "center" },
  { field: "surveyDate", headerName: "Ultima respuesta", type: "dateTime", width: 130 },
  { field: "identificationNumber", headerName: "Identificación", width: 120 },
  { field: "entityCode", headerName: "Código empresa", type: "string", width: 120, align: "center" },
  { field: "isTemporary", headerName: "Es temporal?", type: "string", width: 100, align: "center" },
  { field: "status", headerName: "Estado", type: "string", width: 90, align: "center" },
  { field: "fullName", headerName: "Nombre Completo", width: 270 },
  { field: "firstName", headerName: "Primer Nombre", width: 150 },
  { field: "lastName", headerName: "Apellido", width: 150 },
  { field: "genderName", headerName: "Género", type: "string", width: 100, align: "center" },
  { field: "countryBirth", headerName: "País de nacimiento", width: 150, align: "center" },
  { field: "stateBirth", headerName: "Departamento de nacimiento", width: 220, align: "center" },
  { field: "cityBirth", headerName: "Ciudad de nacimiento", width: 160, align: "center" },
  { field: "birthDate", headerName: "Fecha de nacimiento", type: "dateTime", width: 170, align: "center" },
  { field: "maritalStatus", headerName: "Estado civil", type: "text", width: 100, align: "center" },
  { field: "vulnerableGroup", headerName: "Grupo vulnerable", type: "string", width: 300 },
  { field: "socialProgramCategory", headerName: "Grupo SISBEN", type: "string", width: 170, align: "center" },
  { field: "jobPosition", headerName: "Cargo actual", type: "string", width: 170 },
  { field: "ccf", headerName: "Caja de compensación", type: "string", width: 450 },
  { field: "afp", headerName: "Fondo de pensiones", type: "string", width: 450 },
  { field: "fces", headerName: "Fondo de Cesantías", type: "string", width: 350 },
  { field: "eps", headerName: "EPS", type: "string", width: 450 },
  { field: "idLugarTrabajo", headerName: "ID Lugar de trabajo", type: "string", width: 150 },
  { field: "lugarTrabajo", headerName: "Lugar de trabajo", type: "string", width: 255 },
  { field: "idCentroCosto", headerName: "ID Centro de costos", type: "string", width: 150 },
  { field: "centroCosto", headerName: "Centro de costos", type: "string", width: 255 },
  { field: "cellPhone", headerName: "Tiene celular?", type: "string", width: 170, align: "center" },
  { field: "cellPhoneNumber", headerName: "Número celular", type: "string", width: 170 },
  { field: "providerCellPhone", headerName: "Operador Móvil", type: "string", width: 170 },
  { field: "eMail", headerName: "Correo electrónico", type: "string", width: 300 },
  {
    field: "emergencyContactName",
    headerName: "Nombre contacto de emergencia",
    type: "string",
    width: 230,
    align: "center",
  },
  {
    field: "emergencyContactRelationship",
    headerName: "Parentesco con el contacto de emergencia",
    type: "string",
    width: 300,
    align: "center",
  },
  {
    field: "emergencyContactPhoneNumber",
    headerName: "Teléfono del contacto de emergencia",
    type: "string",
    width: 260,
    align: "center",
  },

  { field: "transportationMode", headerName: "Medio de transporte", type: "string", width: 170 },
  { field: "transportTime", headerName: "Tiempo de desplazamiento", type: "string", width: 200 },
  { field: "brigadeMember", headerName: "Es brigadista?", type: "string", width: 170, align: "center" },
  { field: "employeeFund", headerName: "Pertenece a fondo de emplados?", type: "string", width: 230, align: "center" },
  { field: "countryResidence", headerName: "País de residencia", type: "string", width: 170 },
  { field: "stateResidence", headerName: "Departamento de residencia", type: "string", width: 200 },
  { field: "cityResidence", headerName: "Ciudad de residencia", type: "string", width: 170 },
  { field: "neighborhood", headerName: "Vereda o Barrio", type: "string", width: 200 },
  { field: "address", headerName: "Dirección", type: "string", width: 200 },
  { field: "livingPlaceYear", headerName: "Desde que año reside?", type: "string", width: 170, align: "center" },
  { field: "zoneResidence", headerName: "Zona de vivienda", type: "string", width: 130, align: "center" },
  { field: "socialClassLevel", headerName: "Estrato", type: "string", width: 70, align: "center" },
  { field: "houseType", headerName: "Tipo de vivienda", type: "string", width: 130, align: "center" },
  { field: "housingTenureType", headerName: "Tipo de tenencia de la vivienda", type: "string", width: 220 },
  { field: "housingStatus", headerName: "Estado de la vivienda", type: "string", width: 150, align: "center" },
  {
    field: "roomsAmount",
    headerName: "Cantidad de espacios destinados como dormitorio",
    type: "number",
    width: 350,
    align: "center",
  },
  { field: "publicServices", headerName: "Servicios públicos disponibles en la vivienda ", type: "string", width: 470 },
  { field: "homeAsset", headerName: "vienes que posee en el hogar", type: "string", width: 1500 },
  { field: "techAsset", headerName: "vienes tecnológicos que posee en el hogar", type: "string", width: 500 },
  { field: "computersAmount", headerName: "Cantidad de computadores", type: "string", width: 200, align: "center" },
  { field: "socialMedia", headerName: "Redes sociales", type: "string", width: 370 },
  { field: "ownHome", headerName: "Vivienda propia?", type: "string", width: 120, align: "center" },
  { field: "houseDeed", headerName: "Titular de las escrituras", type: "string", width: 170, align: "center" },
  { field: "ownLand", headerName: "Lote propio?", type: "string", width: 100, align: "center" },
  { field: "landDeed", headerName: "Titular del Lote", type: "string", width: 120, align: "center" },
  { field: "primaryFamilyGroup", headerName: "Grupo familiar", type: "string", width: 270 },
  { field: "familyGroupPosition", headerName: "Posición dentro del grupo familiar", type: "string", width: 350 },
  { field: "spouse", headerName: "Tiene pareja?", type: "string", width: 110, align: "center" },
  {
    field: "birthdateSpouse",
    headerName: "Fecha de nacimiento de la pareja",
    type: "string",
    width: 230,
    align: "center",
  },
  { field: "spouseGender", headerName: "Género", type: "string", width: 100 },
  { field: "liveTogether", headerName: "Vive con su pareja?", type: "string", width: 140, align: "center" },
  { field: "spouseOccupation", headerName: "Ocupación de la pareja", type: "string", width: 170, align: "center" },
  {
    field: "worksInFlowerCompany",
    headerName: "Trabaja en empresa de flores?",
    type: "string",
    width: 230,
    align: "center",
  },
  { field: "sectorJobSpouse", headerName: "En que sector trabaja?", type: "string", width: 160, align: "center" },
  { field: "educationLevelSpouse", headerName: "Último nivel educativo aprobado", type: "string", width: 230 },
  { field: "currentlyStudyingSpouse", headerName: "Actualmente estudia?", type: "string", width: 160, align: "center" },
  {
    field: "contributeFinanciallySpouse",
    headerName: "Aporta económicamente al hogar?",
    type: "string",
    width: 240,
    align: "center",
  },
  {
    field: "isFinanciallyDependent",
    headerName: "Es dependiente económicamente?",
    type: "string",
    width: 240,
    align: "center",
  },
  { field: "isSpouseDisabled", headerName: "Presenta discapacidad?", type: "string", width: 170, align: "center" },
  { field: "disabilitySpouse", headerName: "Tipo de discapacidad", type: "string", width: 270 },
  { field: "hasChildren", headerName: "Tiene hijos?", type: "string", width: 95, align: "center" },
  { field: "childrenAmount", headerName: "Cantidad de hijos", type: "string", width: 130, align: "center" },
  { field: "educationLevel", headerName: "Nivel de formación", type: "string", width: 190 },
  { field: "profession", headerName: "Título recibido", type: "string", width: 270 },
  { field: "currentlyStudying", headerName: "Actualmente estudia?", type: "string", width: 160, align: "center" },
  { field: "studies", headerName: "Estudios actuales", type: "string", width: 170 },
  { field: "studyModality", headerName: "Modalidad de estudio", type: "string", width: 160, align: "center" },
  { field: "studyDays", headerName: "Días de estudio", type: "string", width: 150 },
  { field: "studySchedule", headerName: "Horario de estudio", type: "string", width: 140, align: "center" },
  { field: "SpeakAnotherLanguage", headerName: "Habla otro Idioma?", type: "string", width: 180 },
  { field: "Language", headerName: "Idiomas que habla", type: "string", width: 200 },
  { field: "LanguageLevel", headerName: "Nivel de manejo Idioma", type: "string", width: 200 },
  { field: "computerKnowledge", headerName: "Nivel de conocimiento de computadores", type: "string", width: 1800 },
  {
    field: "trainingNeeds",
    headerName: "Necesitades de formación o capacitación que considera prioritarias",
    type: "string",
    width: 1700,
  },
  { field: "additionaIIncome", headerName: "Ingresos adicionales?", type: "string", width: 170, align: "center" },
  { field: "incomeType", headerName: "Tipo de ingresos adicionales", type: "string", width: 570 },
  { field: "incomeAverage", headerName: "Promedio de los ingresos", type: "number", width: 180, align: "center" },
  { field: "incomeDestinations", headerName: "Destino de los ingresos adicionales", type: "string", width: 1100 },
  { field: "insurancePolicies", headerName: "Polizas", type: "string", width: 270 },
  {
    field: "hasComplementaryHealthPlan",
    headerName: "Cuenta con plan complementario?",
    type: "string",
    width: 240,
    align: "center",
  },
  { field: "complementaryHealthPlan", headerName: "Planes complentarios de salud", type: "string", width: 670 },
  { field: "stores", headerName: "Lugares de compra de alimentos para el hogar", type: "string", width: 520 },
  {
    field: "frequencyPurchases",
    headerName: "Frecuencia de compra alimentos",
    type: "string",
    width: 230,
    align: "center",
  },
  { field: "consumerFoods", headerName: "Alimentos de mayor consumo en el hogar", type: "string", width: 870 },
  {
    field: "self_ConsumptionFood",
    headerName: "Produce alimentos para autoconsumo?",
    type: "string",
    width: 270,
    align: "center",
  },
  {
    field: "waterFrequency",
    headerName: "Frecuencia disponible de agua para consumo",
    type: "string",
    width: 310,
    align: "center",
  },
  {
    field: "dailyFullMeal",
    headerName: "Cantidad de comidas completas por dia",
    type: "string",
    width: 270,
    align: "center",
  },
  {
    field: "shortTermProject",
    headerName: "Proyecto o meta a corto plazo?",
    type: "string",
    width: 220,
    align: "center",
  },
  { field: "short_TermProjectsType", headerName: "Tipo de proyecto a corto plazo", type: "string", width: 570 },
  { field: "problemsAchieveGoals", headerName: "Que falta para cumplirlo ?", type: "string", width: 370 },
  { field: "concerns", headerName: "Aspectos de la vida con mas necesidades", type: "string", width: 570 },
  { field: "hobbies", headerName: "Actvidades que realiza en su tiempo libre", type: "string", width: 1450 },
  {
    field: "desiredHobbies",
    headerName: "Actvidades que le gustaria realizar",
    type: "string",
    width: 470,
    align: "center",
  },
  {
    field: "problemsAchieveHobbies",
    headerName: "Que le falta para realizarlas?",
    type: "string",
    width: 470,
    align: "center",
  },
  {
    field: "communityActivities",
    headerName: "Participa en actividades comunitarias?",
    type: "string",
    width: 270,
    align: "center",
  },
];

export const employeesFileColumns = {
  surveyId: "Identificación de la encuesta",
  surveyStatus: "Estado de la encuesta",
  surveySections: "Secciones de la encuesta",
  surveyPercentage: "Porcentaje de encuesta",
  surveyDate: "Fecha de encuesta",
  identificationNumber: "Número de identificación",
  fullName: "Nombre completo",
  firstName: "Primer nombre",
  lastName: "Apellido",
  genderName: "Género",
  countryBirth: "País de nacimiento",
  stateBirth: "Departamento de nacimiento",
  cityBirth: "Ciudad de nacimiento",
  birthDate: "Fecha de nacimiento",
  maritalStatus: "Estado civil",
  vulnerableGroup: "Grupo vulnerable",
  socialProgramCategory: "Categoría de programa social",
  entityCode: "Código de entidad",
  status: "Estado",
  isTemporary: "Es temporal",
  jobPosition: "Cargo",
  ccf: "Caja de compensación",
  afp: "Fondo de pensiones",
  fces: "Fondo de Cesantías",
  eps: "EPS",
  cellPhone: "Celular",
  cellPhoneNumber: "Número de celular",
  providerCellPhone: "Proveedor de celular",
  eMail: "Correo electrónico",
  transportationMode: "Modo de transporte",
  transportTime: "Tiempo de transporte",
  brigadeMember: "Miembro de brigada",
  employeeFund: "Fondo de empleados",
  countryResidence: "País de residencia",
  stateResidence: "Departamento de residencia",
  cityResidence: "Ciudad de residencia",
  neighborhood: "Barrio",
  address: "Dirección",
  livingPlaceYear: "Años de residencia",
  zoneResidence: "Zona de residencia",
  socialClassLevel: "Nivel de clase social",
  houseType: "Tipo de vivienda",
  housingTenureType: "Tipo de tenencia de vivienda",
  housingStatus: "Estado de vivienda",
  roomsAmount: "Cantidad de habitaciones",
  publicServices: "Servicios públicos",
  homeAsset: "Activo de vivienda",
  techAsset: "Activo tecnológico",
  computersAmount: "Cantidad de computadoras",
  socialMedia: "Redes sociales",
  ownHome: "Casa propia",
  houseDeed: "Escritura de casa",
  ownLand: "Terreno propio",
  landDeed: "Escritura de terreno",
  primaryFamilyGroup: "Grupo familiar primario",
  familyGroupPosition: "Posición en el grupo familiar",
  spouse: "Cónyuge",
  birthdateSpouse: "Fecha de nacimiento del cónyuge",
  spouseGender: "Género del cónyuge",
  liveTogether: "Conviven",
  spouseOccupation: "Ocupación del cónyuge",
  worksInFlowerCompany: "Trabaja en empresa floricultora",
  sectorJobSpouse: "Sector laboral del cónyuge",
  educationLevelSpouse: "Nivel educativo del cónyuge",
  currentlyStudyingSpouse: "Estudia actualmente el cónyuge",
  contributeFinanciallySpouse: "Contribuye financieramente el cónyuge",
  isFinanciallyDependent: "Es dependiente económicamente",
  isSpouseDisabled: "Cónyuge con discapacidad",
  disabilitySpouse: "Discapacidad del cónyuge",
  hasChildren: "Tiene hijos",
  childrenAmount: "Cantidad de hijos",
  educationLevel: "Nivel educativo",
  profession: "Profesión",
  currentlyStudying: "Estudia actualmente",
  studies: "Estudios",
  studyModality: "Modalidad de estudio",
  studyDays: "Días de estudio",
  studySchedule: "Horario de estudio",
  computerKnowledge: "Conocimiento en computadoras",
  trainingNeeds: "Necesidades de capacitación",
  additionaIIncome: "Ingresos adicionales",
  incomeType: "Tipo de ingreso",
  incomeAverage: "Promedio de ingresos",
  incomeDestinations: "Destinos de ingresos",
  insurancePolicies: "Pólizas de seguro",
  hasComplementaryHealthPlan: "Tiene plan de salud complementario",
  complementaryHealthPlan: "Plan de salud complementario",
  stores: "Tiendas",
  frequencyPurchases: "Frecuencia de compras",
  consumerFoods: "Alimentos de consumo",
  self_ConsumptionFood: "Autoconsumo de alimentos",
  waterFrequency: "Frecuencia de consumo de agua",
  dailyFullMeal: "Comida diaria completa",
  shortTermProject: "Proyecto a corto plazo",
  short_TermProjectsType: "Tipo de proyectos a corto plazo",
  problemsAchieveGoals: "Problemas para lograr metas",
  concerns: "Preocupaciones",
  hobbies: "Pasatiempos",
  communityActivities: "Actividades comunitarias",
  speakAnotherLanguage: "Habla otro idioma",
  language: "Idioma",
  languageLevel: "Nivel de idioma",
  desiredHobbies: "Hobbies deseados",
  problemsAchieveHobbies: "Problemas para lograr hobbies",
  emergencyContactName: "Nombre de contacto de emergencia",
  emergencyContactRelationship: "Relación con el contacto de emergencia",
  emergencyContactPhoneNumber: "Número de teléfono de contacto de emergencia",
  idLugarTrabajo: "ID Lugar de Trabajo",
  lugarTrabajo: "Lugar de Trabajo",
  idCentroCosto: "ID Centro de Costos",
  centroCosto: "Centro de Costos",
};

export const childrenColumns: GridColDef[] = [
  { field: "surveyId", headerName: "Orden", width: 70, align: "center" },
  { field: "surveyDate", headerName: "Fecha de la encuesta", type: "string", width: 170, align: "center" },
  { field: "fullName", headerName: "Nombre colaborador", type: "string", width: 270 },
  { field: "isTemporary", headerName: "Es temporal?", type: "string", width: 100, align: "center" },
  { field: "status", headerName: "Estado", type: "string", width: 90, align: "center" },
  { field: "name", headerName: "Nombre", type: "string", width: 270 },
  {
    field: "identificationNumber",
    headerName: "Número de identificación",
    type: "string",
    width: 185,
    align: "center",
  },
  { field: "birthDate", headerName: "Fecha de nacimiento", type: "string", width: 170, align: "center" },
  { field: "genderName", headerName: "Género", type: "string", width: 270 },
  { field: "activities", headerName: "Actividades", type: "string", width: 170 },
  { field: "ageRange", headerName: "Rango de edad", type: "string", width: 170, align: "center" },
  { field: "liveWithYou", headerName: "Convive con el trabajador?", type: "string", width: 190, align: "center" },
  { field: "familyType", headerName: "Tipo", type: "string", width: 90 },
  { field: "financiallyDependent", headerName: "Depende del trabajador?", type: "string", width: 170, align: "center" },
  { field: "contributeFinancially", headerName: "Aporta económicamente", type: "string", width: 180, align: "center" },
  { field: "FamilyAllowance", headerName: "¿Recibe subsidio familiar?", type: "string", width: 180, align: "center" },
  { field: "currentlyStudying", headerName: "Estudia actualmente?", type: "string", width: 170, align: "center" },
  { field: "educationLevel", headerName: "Nivel de estudios", type: "string", width: 170 },
  { field: "transportMode", headerName: "Medio de transporte", type: "string", width: 270 },
  { field: "entityCode", headerName: "Código entidad", type: "string", width: 120, align: "center" },
  { field: "properties", headerName: "bienes que posee su hijo", type: "string", width: 270 },
  { field: "whoTakesCare", headerName: "Quien cuida de su hijo", type: "string", width: 270 },
  {
    field: "participateInActivities",
    headerName: "Participa en actividades extracurriculares?",
    type: "string",
    width: 290,
    align: "center",
  },
  { field: "isDisabled", headerName: "Presenta discapacidad?", type: "string", width: 170, align: "center" },
  { field: "disability", headerName: "Tipo de discapacidad", type: "string", width: 170, align: "center" },
  { field: "relationship", headerName: "Tipo de relación", type: "string", width: 270 },
];

export const childrenFileColumns = {
  surveyId: "Identificación de la encuesta",
  surveyDate: "Fecha de la encuesta",
  entityCode: "Código de entidad",
  isTemporary: "Es temporal",
  status: "Estado",
  identificationNumber: "Número de identificación",
  fullName: "Nombre completo",
  familyType: "Tipo de familia",
  consecutive: "Consecutivo",
  name: "Nombre",
  birthDate: "Fecha de nacimiento",
  liveWithYou: "Vive contigo",
  whoTakesCare: "Quién cuida",
  isDisabled: "Tiene discapacidad",
  disability: "Tipo de discapacidad",
  contributeFinancially: "Contribuye financieramente",
  financiallyDependent: "Es dependiente económico",
  educationLevel: "Nivel educativo",
  currentlyStudying: "Estudia actualmente",
  transportMode: "Modo de transporte",
  properties: "Propiedades",
  participateInActivities: "Participa en actividades",
  activities: "Actividades",
  genderName: "Género",
  relationship: "Relación",
  ageRange: "Rango de edad",
  familyAllowance: "Subsidio familiar",
};

export const relativeColumns: GridColDef[] = [
  { field: "surveyId", headerName: "Orden", width: 70, align: "center" },
  { field: "surveyDate", headerName: "Fecha de la encuesta", type: "string", width: 170, align: "center" },
  { field: "fullName", headerName: "Nombre colaborador", type: "string", width: 270 },
  { field: "isTemporary", headerName: "Es temporal?", type: "string", width: 100, align: "center" },
  { field: "status", headerName: "Estado", type: "string", width: 90, align: "center" },
  { field: "name", headerName: "Nombre", type: "string", width: 270 },
  {
    field: "identificationNumber",
    headerName: "Número de identificación",
    type: "string",
    width: 180,
    align: "center",
  },
  { field: "birthDate", headerName: "Fecha de nacimiento", type: "string", width: 150, align: "center" },
  { field: "ageRange", headerName: "Rango de Edad", type: "string", width: 150 },
  { field: "contributeFinancially", headerName: "Aporta económicamente", type: "string", width: 175, align: "center" },
  { field: "FamilyAllowance", headerName: "¿Recibe subsidio familiar?", type: "string", width: 180, align: "center" },
  { field: "currentlyStudying", headerName: "Estudia actualmente?", type: "string", width: 155, align: "center" },
  { field: "relationship", headerName: "Tipo de relación", type: "string", width: 160, align: "center" },
  { field: "educationLevel", headerName: "Nivel de estudios", type: "string", width: 270 },
  { field: "entityCode", headerName: "Código entidad", type: "string", width: 120, align: "center" },
  { field: "familyType", headerName: "Parentesco", type: "string", width: 110, align: "center" },
  { field: "financiallyDependent", headerName: "Depende económicamente?", type: "string", width: 195, align: "center" },
  { field: "genderName", headerName: "Género", type: "string", width: 100, align: "center" },
  { field: "liveWithYou", headerName: "Convive con el trabajador?", type: "string", width: 195, align: "center" },
  { field: "properties", headerName: "Bienes personales", type: "string", width: 270 },
  { field: "isDisabled", headerName: "Presenta discapacidad?", type: "string", width: 170, align: "center" },
  { field: "disability", headerName: "Tipo de discapacidad", type: "string", width: 270 },
];

export const relativeFileColumns = {
  surveyId: "Id Encuesta",
  surveyDate: "Fecha de la encuesta",
  entityCode: "Código entidad",
  isTemporary: "Es temporal?",
  status: "Estado",
  identificationNumber: "Número de identificación",
  fullName: "Nombre colaborador",
  familyType: "Parentesco",
  consecutive: "Orden",
  name: "Nombre",
  birthDate: "Fecha de nacimiento",
  liveWithYou: "Convive con el trabajador?",
  whoTakesCare: "Quién lo cuida",
  isDisabled: "Tiene discapacidad",
  disability: "Tipo de discapacidad",
  contributeFinancially: "Aporta económicamente",
  financiallyDependent: "Depende económicamente?",
  educationLevel: "Nivel de estudios",
  currentlyStudying: "Estudia actualmente?",
  transportMode: "Tipo de transporte",
  properties: "Bienes personales",
  participateInActivities: "Participa en actividades",
  activities: "Actividades",
  genderName: "Género",
  relationship: "Tipo de relación",
  ageRange: "Rango de Edad",
  familyAllowance: "¿Recibe subsidio familiar?",
};
